import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'driveway-and-footpath-excavation-sydney';
const serviceId = 2
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Driveway & Footpath Excavation Sydney | ${BUSINESS_NAME}`,
        description: "Expert excavation for new driveways, footpaths, and walkways, ensuring a clean foundation ready for concreting or paving.",
        keywords: "driveway excavation sydney, footpath excavation, walkway excavation, site preparation, trenching services, landscaping excavation, residential excavation, commercial excavation, custom excavation solutions, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Driveway & Footpath Excavation',
    description: 'Expert excavation for new driveways, footpaths, and walkways, ensuring a clean foundation ready for concreting or paving.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
